import { motion, useReducedMotion } from "framer-motion";

import Meta from "./meta";

// Every view mounts with the same short rise: responsiveness, not an animation.
const Page = ({ page, className = "", children }) => {
	const reduceMotion = useReducedMotion();

	return (
		<motion.main
			id="top"
			className={className}
			initial={reduceMotion ? false : { opacity: 0, y: 6 }}
			animate={{ opacity: 1, y: 0 }}
			exit={
				reduceMotion
					? undefined
					: { opacity: 0, transition: { duration: 0.18 } }
			}
			transition={{ duration: 0.46, ease: [0.22, 0.61, 0.36, 1] }}
		>
			<Meta page={page} />
			{children}
		</motion.main>
	);
};

export default Page;
